import { useState } from "react";
import Lenis from "lenis";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import TourShowcase from "@/components/TourShowcase";
import Fleet from "@/components/Fleet";
import Manifesto from "@/components/Manifesto";
import Expertise from "@/components/Expertise";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";

function App() {
  const [selectedService, setSelectedService] = useState("private-transfers");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  const handleBookService = (slug) => {
    setSelectedService(slug);
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#050505] text-[#fcfcfc] min-h-screen" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services onBook={handleBookService} />
        <TourShowcase onBook={handleBookService} />
        <Fleet />
        <Manifesto />
        <Expertise />
        <BookingForm
          service={selectedService}
          onServiceChange={setSelectedService}
        />
      </main>
      <Footer />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
